<template>
    <table class="ui celled selectable single line table cell_input_table">
        <thead>
            <tr>
                <th style="white-space: nowrap;">
                    <!-- {{ waybill_raw_datas.length }} 筆 -->
                    {{ $t('ui.pages.uploader.total__number',{number: waybill_raw_datas.length}) }}
                </th>
                <th v-for="(conversion, index) in conversions" :key="index" style="white-space: nowrap;">
                    {{ conversion.header_text }}
                </th>
            </tr>
        </thead>

        <tbody>
            <tr
            is="Waybill"
            v-for="(waybill_raw_data, index) in waybill_raw_datas"
            :key="waybill_raw_data.number"
            :conversions="conversions"
            :waybill_raw_data="waybill_raw_data"
            :data-total-row="waybill_raw_datas.length"
            :data-total-column="conversions.length"
            :data-row="index + 1"
            :group="group"
            ></tr>
        </tbody>

        <tfoot>
            <tr>
                <th>
                    <!-- {{ waybill_raw_datas.length }} 筆 -->
                    {{ $t('ui.pages.uploader.total__number',{number: waybill_raw_datas.length}) }}
                </th>
                <th :colspan="conversions.length" align="right">
                    <!-- 總計 -->
                    {{ $t('ui.pages.uploader.total') }}
                </th>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import Waybill from './waybill.vue'

export default {
    name: "UploaderWaybills",
    props: {
        operation_identity: String,
        group: String
    },
    data() {
        return {
            validated_counter: 0,
            uploaded_counter: 0,
            batch_counter: 0,
            batch_limit: 1
        }
    },
    mounted() {
        this.$bus.$off(this.group + 'broadcast_validate_waybills')
        this.$bus.$on(this.group + 'broadcast_validate_waybills', () => {
            this.validated_counter = 0
            this.group_validate_waybills()
        })

        this.$bus.$off(this.group + 'broadcast_create_waybills')
        this.$bus.$on(this.group + 'broadcast_create_waybills', () => {
            this.uploaded_counter = 0
            this.group_create_waybills()
        })
    },
    watch: {

    },
    computed: {
        current_scope() {
            return this.$store.state.current_scope
        },
        current_scoped_store() {
            return this.$store.state[this.current_scope]
        },
        waybill_raw_datas() {
            return this.current_scoped_store.uploader_module.waybill_raw_datas[this.group]
        },
        conversions() {
            return this.current_scoped_store.uploader_module.conversions
        },
        operation() {
            return this.$parent
        },
        validate_waybill_url() {
            return this.current_scoped_store.uploader_module.validate_waybill_url
        },
        use_waybill_url() {
            return this.current_scoped_store.uploader_module.use_waybill_url
        },
        requester_node() {
            return this.current_scoped_store.uploader_module.requester_node
        },
        requester_contract() {
            return this.current_scoped_store.uploader_module.requester_contract
        },
    },
    methods: {
        group_validate_waybills() {
            _.forEach(this.$children, (component, key) => {
                component.is_processing = true
            })
            // 組成參數
            switch (this.current_scope) {
                case "customer":
                    var auth_token = localStorage.getItem("customer_authentication_token")
                    break
                case "provider":
                    var auth_token = localStorage.getItem("authentication_token")
                    break
                default:
            }
            if (this.$store.state[this.current_scope].uploader_module.current_converter.skip_usable_validation && this.$store.state[this.current_scope].uploader_module.current_converter.skip_operation_creation) {
                // 純更新，查找已存在運單

                var all_numbers = _.map(this.waybill_raw_datas, "number");

                all_numbers = all_numbers.filter(function( element ) {
                return element !== undefined;
                });

                if(all_numbers.toString()) {
                    var data = {
                        numbers: _.uniq(_.map(this.waybill_raw_datas, "number")),
                        find_existed_core_waybills: true,
                    }
                } else {
                    var data = {
                        original_numbers: _.uniq(_.map(this.waybill_raw_datas, "existed_original_number")),
                        find_existed_core_waybills_via_original_number: true,
                    }
                }
                
                axios.post(this.validate_waybill_url, data, {headers: { Authorization: auth_token }})
                    .then(response => {
                        let number_type = response.data.method == "find_existed_core_waybills_via_original_number" ? "existed_original_number" : "number"
                        if (response.data.status == "success") {
                            _.forEach(this.$children, (component, key) => {
                                if (response.data.found_core_waybills.indexOf(component.waybill_raw_data[number_type].toString()) != -1) {
                                    // 單號屬於查號成功陣列的場合
                                    component.is_failed = false
                                    component.is_checked = true
                                    component.status = "查號成功"
                                    component.frontend_validation()
                                } else if (response.data.not_found_core_waybills.indexOf(component.waybill_raw_data[number_type].toString()) != -1) {
                                    // 單號屬於查號失敗陣列的場合
                                    component.is_failed = true
                                    component.is_checked = false
                                    component.status = "查號失敗"
                                    component.$bus.$emit(this.group + 'add_errors', component.waybill_raw_data[number_type] + " 查號失敗: 查無此單")
                                    component.is_processing = false
                                    component.$bus.$emit(this.group + 'add_complete_count')
                                } else {
                                    // 單號不屬於任一陣列的場合
                                    component.is_failed = true
                                    component.is_checked = false
                                    component.status = "回應異常"
                                    component.$bus.$emit(this.group + 'add_errors', "查號失敗: 無法辨識的運單")
                                    component.is_processing = false
                                    component.$bus.$emit(this.group + 'add_complete_count')
                                }
                            })
                        } else {
                            _.forEach(response.data.errors, (error, key) => {
                                _.forEach(error, (message, key) => {
                                    this.operation.errors.push("查號失敗: " + message)
                                })
                            })
                            _.forEach(this.$children, (component, key) => {
                                // 單號屬於查號失敗陣列的場合
                                component.is_failed = true
                                component.is_checked = false
                                component.status = "查號失敗"
                                component.is_processing = false
                                component.$bus.$emit(this.group + 'add_complete_count')
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.operation.errors.push("查號異常")
                    })
            } else {
                // 送自動取號驗證
                var data = {
                    core_waybills: _.uniq(_.map(_.groupBy(this.waybill_raw_datas, 'number_picker')["automatic"], (waybill_raw_data) => {
                        return {
                            number: waybill_raw_data.number,
                            material_class_name: waybill_raw_data.material_class_name,
                        }
                    })),
                    automatic_number_picker: true,
                }
                axios.post(this.validate_waybill_url, data, {headers: { Authorization: auth_token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            _.forEach(this.$children, (component, key) => {
                                component.is_failed = false
                                component.is_checked = true
                                component.status = "取號成功"
                                component.frontend_validation()
                            })
                        } else {
                            this.operation.errors.push("取號失敗: " + response.data.errors)
                            _.forEach(this.$children, (component, key) => {
                                component.is_failed = true
                                component.is_checked = false
                                component.status = "取號失敗"
                                component.is_processing = false
                                component.$bus.$emit(this.group + 'add_complete_count')
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.operation.errors.push("取號異常")
                    })
                // 送手動取號驗證
                var data = {
                    core_waybills: _.uniq(_.map(_.groupBy(this.waybill_raw_datas, 'number_picker')["manual"], (waybill_raw_data) => {
                        return {
                            number: waybill_raw_data.number,
                            material_class_name: waybill_raw_data.material_class_name,
                        }
                    })),
                    customer_identity: this.requester_node.identity,
                    contract_identity: this.requester_contract.identity,
                }
                if (this.$store.state[this.current_scope].uploader_module.current_converter.ignore_customer_node) {
                    data.internal_only = true
                }
                axios.post(this.validate_waybill_url, data, {headers: { Authorization: auth_token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            _.forEach(this.$children, (component, key) => {
                                if (response.data.usable_core_waybills.indexOf(component.waybill_raw_data.number) != -1) {
                                    // 單號屬於取號成功陣列的場合
                                    component.is_failed = false
                                    component.is_checked = true
                                    component.status = "取號成功"
                                    component.frontend_validation()
                                } else if (response.data.unusable_core_waybills.indexOf(component.waybill_raw_data.number) != -1) {
                                    // 單號屬於取號失敗陣列的場合
                                    component.is_failed = true
                                    component.is_checked = false
                                    component.status = "取號失敗"
                                    component.$bus.$emit(this.group + 'add_errors', component.waybill_raw_data.number + " 取號失敗: 不可用的號碼(不存在或已經使用過)")
                                    component.is_processing = false
                                    component.$bus.$emit(this.group + 'add_complete_count')
                                }
                            })
                        } else {
                            _.forEach(response.data.errors, (error, key) => {
                                _.forEach(error, (message, key) => {
                                    this.operation.errors.push("取號失敗: " + message)
                                })
                            })
                            _.forEach(this.$children, (component, key) => {
                                // 單號屬於取號失敗陣列的場合
                                component.is_failed = true
                                component.is_checked = false
                                component.status = "取號失敗"
                                component.is_processing = false
                                component.$bus.$emit(this.group + 'add_complete_count')
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.operation.errors.push("取號異常")
                    })
            }

            // axios.post(this.validate_waybill_url, data, {headers: { Authorization: auth_token }})
            //     .then(response => {
            //         if (response.data.status == "success") {
            //             _.forEach(this.$children, (component, key) => {
            //                 if (response.data.success_numbers.indexOf(component.waybill_raw_data.number) != -1) {
            //                     // 單號屬於取號成功陣列的場合
            //                     component.is_failed = false
            //                     component.is_checked = true
            //                     component.status = "取號成功"
            //                     component.frontend_validation()
            //                 } else if (response.data.failure_numbers.indexOf(component.waybill_raw_data.number) != -1) {
            //                     // 單號屬於取號失敗陣列的場合
            //                     component.is_failed = true
            //                     component.is_checked = false
            //                     component.status = "取號失敗"
            //                     component.$bus.$emit(this.group + 'add_errors', component.waybill_raw_data.number + " 取號失敗: 不可用的號碼")
            //                     component.is_processing = false
            //                     component.$bus.$emit(this.group + 'add_complete_count')
            //                 } else {
            //                     // 單號不屬於任一陣列的場合
            //                     component.is_failed = true
            //                     component.is_checked = false
            //                     component.status = "回應異常"
            //                     component.$bus.$emit(this.group + 'add_errors', component.waybill_raw_data.number + " 取號異常: 伺服器未回應本單號")
            //                     component.is_processing = false
            //                     component.$bus.$emit(this.group + 'add_complete_count')
            //                 }
            //             })
            //         } else {
            //             _.forEach(response.data.errors, (error, key) => {
            //                 _.forEach(error, (message, key) => {
            //                     this.operation.errors.push("取號失敗: " + message)
            //                 })
            //             })
            //             _.forEach(this.$children, (component, key) => {
            //                 // 單號屬於取號失敗陣列的場合
            //                 component.is_failed = true
            //                 component.is_checked = false
            //                 component.status = "取號失敗"
            //                 component.is_processing = false
            //                 component.$bus.$emit(this.group + 'add_complete_count')
            //             })
            //         }
            //     })
            //     .catch(error => {
            //         console.log(response)
            //         this.operation.errors.push("取號伺服器異常: " + error.response.status + error.response.data)
            //     })
        },
        group_create_waybills() {
            var timer = 0
            var house_number_grouped_components = _.groupBy(this.$children, 'waybill_raw_data.house_number')
            _.forEach(house_number_grouped_components, (current_components_collection, house_number) => {
                var waybill_number_grouped_components = _.groupBy(current_components_collection, 'waybill_raw_data.number')
                _.forEach(waybill_number_grouped_components, (current_components_collection, waybill_number) => {
                    var params = {}
                    var params_part1 = {
                        "number": waybill_number,
                        // "waybill_type": "Waybill",
                        "child_core_waybills": _.map(current_components_collection, (component) => {
                            // var data = _.extend({}, {component.waybill_raw_data}, {"waybill_type": "SubWaybill", "core_waybill_level": -1})
                            var data = {
                                // waybill_type: "SubWaybill",
                                number: component.waybill_raw_data.sub_waybill_number,
                            }
                            return data
                        })
                    }
                    var params_part2 = current_components_collection[0].waybill_raw_data
                    delete params_part2.sub_waybill_number
                    delete params_part2.house_number
                    params = Object.assign({}, params_part1, params_part2)

                    // console.log(params)

                    setTimeout(() => {
                        this.group_send_create(current_components_collection, params)
                    }, timer * 250)
                    timer++
                })
            })
            timer = 0
        },
        group_send_create(current_components_collection, params) {
            console.log(params)
            var available_for_creation = true
            // 檢查components是否已經完成
            _.forEach(current_components_collection, (component, key) => {
                component.is_processing = true
                component.is_failed = false
                if (component.is_uploaded == true) {
                    available_for_creation = false
                    component.is_processing = false
                    component.$bus.$emit(this.group + 'add_complete_count')
                }
            })
            // 若尚未完成才發出create request
            if (available_for_creation) {
                var url = new RestUrl(this.use_waybill_url).parse(
                    {
                        "operation_identity": this.operation_identity
                    },
                )
                if (this.$store.state.current_scope == "provider") {
                    var auth_token = localStorage.getItem("authentication_token")
                } else if (this.$store.state.current_scope == "customer") {
                    var auth_token = localStorage.getItem("customer_authentication_token")
                }
                return new Promise((resolve, reject) => {
                    axios.post(url, params, {headers: { Authorization: auth_token }})
                        .then(response => {
                            if (response.data.status == 'success') {
                                _.forEach(current_components_collection, (component, key) => {
                                    component.status = "完成"
                                    component.is_failed = false
                                    component.is_uploaded = true
                                    this.$bus.$emit(this.group + 'add_uploaded_count')
                                })
                                _.forEach(current_components_collection, (component, key) => {
                                    component.is_processing = false
                                    this.$bus.$emit(this.group + 'add_complete_count')
                                })
                            } else {
                                _.forEach(current_components_collection, (component, key) => {
                                    component.status = "失敗"
                                    component.is_failed = true
                                    component.is_uploaded = false
                                    this.$bus.$emit(this.group +
                                        'add_errors',
                                        component.waybill_raw_data.number + "(" + component.waybill_raw_data.sub_waybill_number + ") 匯入運單失敗: " + res.errors
                                    )
                                })
                                _.forEach(current_components_collection, (component, key) => {
                                    component.is_processing = false
                                    this.$bus.$emit(this.group + 'add_complete_count')
                                })
                            }
                        })
                        .catch(error => {
                            _.forEach(current_components_collection, (component, key) => {
                                component.status = error.statusText
                                component.is_failed = true
                                component.is_uploaded = false
                                this.$bus.$emit(this.group +
                                    'add_errors',
                                    component.waybill_raw_data.number + "(" + component.waybill_raw_data.sub_waybill_number + ") 匯入運單失敗: " + error.status + " " + error.statusText
                                )
                            })
                            _.forEach(current_components_collection, (component, key) => {
                                component.is_processing = false
                                this.$bus.$emit(this.group + 'add_complete_count')
                            })
                        })
                })
            }
        },
    },
    components: {
        Waybill
    }
}
</script>
<style scoped>

</style>
